import React from "react";
import Navigation from "./Navigation";
import { t, tx } from "../i18n";
import { useFeatures } from "../features";

// Welcome screen: routes between an account and anonymous play.
// Only shown on first launch (no identity in localStorage); a player who
// already has a saved nickname/token goes straight to the lobby.
function Welcome({ onLogin, onAnonymous, onAdmin }) {
  const features = useFeatures();
  return (
    <div class="container">
      <Navigation />
      <div class="Home">
        <div class="centered-content">
          <div class="main-title">{t("welcome.title")}</div>
          <div class="main-subtitle">{t("welcome.subtitle")}</div>
          <div class="btn-group vertical">
            <button class="btn btn-primary" onClick={onLogin}>
              {features.register ? t("welcome.login") : t("welcome.loginOnly")}
            </button>
            <button class="btn" onClick={onAnonymous}>
              {t("welcome.anonymous")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
